module.exports = __webpack_public_path__ + "static/media/traxion2.5abc631e.png";